// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2_sxp","label":"Labeled_label__1gMPM","divider":"Labeled_divider__ELGV6"};